import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app';
import ReactGA from "react-ga4";

// ✅ Initialize Google Analytics
ReactGA.initialize("G-8BDLLE9W3L");
ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });

// ✅ Initialize Meta Pixel
(function(f,b,e,v,n,t,s)
{
  if(f.fbq) return; n = f.fbq = function(){ n.callMethod ?
    n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
  if(!f._fbq) f._fbq = n;
  n.push = n; n.loaded = true; n.version = '2.0';
  n.queue = [];
  t = b.createElement(e); t.async = true;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'));

window.fbq('init', '1499403137983182');
window.fbq('track', 'PageView');

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);